import { Button } from '@/components/ui/shadcn/button'
import { MessageCircleIcon } from 'lucide-react'

interface Props {
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  className?: string
  size?: 'default' | 'sm' | 'lg'
}

export const ChatButton = ({ onClick, disabled, loading, className, size = 'default' }: Props) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={disabled || loading}
      size={size}
      className={className}>
      <MessageCircleIcon />
    </Button>
  )
}
